"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddonCard = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const AddonPriceTag_1 = require("../addon-price-tag/AddonPriceTag");
const IconAdd_1 = require("../icons/IconAdd");
const IconCheckCircle_1 = require("../icons/IconCheckCircle");
const IconRemove_1 = require("../icons/IconRemove");
require("./AddonCard.scss");
const AddonCard = (props) => {
    let footer;
    // Only show buttons in footer if quantity can be changed (minQuantity !== maxQuantity).
    if (props.configAddonItem.minQuantity !== props.configAddonItem.maxQuantity) {
        footer = (react_1.default.createElement("div", { className: "flex-grow-1" },
            react_1.default.createElement(Button_1.default, { key: "add", variant: "outline-dark", size: "sm", disabled: props.quantity >= props.configAddonItem.maxQuantity, onClick: () => props.onQuantityChange(props.quantity + 1), className: "" },
                react_1.default.createElement(IconAdd_1.IconAdd, { size: "20px" })),
            " ",
            react_1.default.createElement(Button_1.default, { key: "remove", variant: "outline-dark", size: "sm", disabled: props.quantity <= props.configAddonItem.minQuantity, onClick: () => props.onQuantityChange(props.quantity - 1), className: "" },
                react_1.default.createElement(IconRemove_1.IconRemove, { size: "20px" })),
            "\u00A0",
            props.configAddonItem.maxQuantity > 1 && (react_1.default.createElement(Form_1.default.Control, { className: "card-quantity", size: "sm", type: "number", value: props.quantity.toString(), onChange: (e) => props.onQuantityChange(parseInt(e.target.value)) }))));
    }
    return (react_1.default.createElement("div", { className: `card-outer ${props.quantity > 0 ? "active" : ""}` },
        react_1.default.createElement(Card_1.default, null,
            react_1.default.createElement("div", { className: "card-img-top", style: {
                    backgroundImage: `url(${props.configAddonItem.getImageUrls()[0]})`,
                } }),
            react_1.default.createElement(Card_1.default.Body, null,
                react_1.default.createElement(Card_1.default.Title, null, props.configAddonItem.title),
                react_1.default.createElement(Card_1.default.Subtitle, { className: "mb-2 text-muted font-weight-normal" }, props.configAddonItem.description),
                react_1.default.createElement("div", { className: "text-muted font-weight-bold card-text" },
                    react_1.default.createElement(AddonPriceTag_1.AddonPriceTag, { priceModel: props.configAddonItem.priceModel, unitSingular: props.configAddonItem.units.singular, maxQuantity: props.configAddonItem.maxQuantity }))),
            react_1.default.createElement(Card_1.default.Footer, { className: "d-flex" }, footer),
            react_1.default.createElement("div", { className: "card-icon" }, props.quantity > 0 && react_1.default.createElement(IconCheckCircle_1.IconCheckCircle, { size: "32.5px" })))));
};
exports.AddonCard = AddonCard;
